/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { SanityChecks, SanityChecksInterface } from "../SanityChecks";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "actual",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "expected",
        type: "uint256",
      },
    ],
    name: "UnexpectedValue",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroAddress",
    type: "error",
  },
];

const _bytecode =
  "0x60566037600b82828239805160001a607314602a57634e487b7160e01b600052600060045260246000fd5b30600052607381538281f3fe73000000000000000000000000000000000000000030146080604052600080fdfea2646970667358221220f0e2178e5366151acd2bc08cdb49f9aae041454a2aea0dfdf1b67f485eaa7e8f64736f6c634300080b0033";

type SanityChecksConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: SanityChecksConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class SanityChecks__factory extends ContractFactory {
  constructor(...args: SanityChecksConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "SanityChecks";
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<SanityChecks> {
    return super.deploy(overrides || {}) as Promise<SanityChecks>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): SanityChecks {
    return super.attach(address) as SanityChecks;
  }
  connect(signer: Signer): SanityChecks__factory {
    return super.connect(signer) as SanityChecks__factory;
  }
  static readonly contractName: "SanityChecks";
  public readonly contractName: "SanityChecks";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): SanityChecksInterface {
    return new utils.Interface(_abi) as SanityChecksInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SanityChecks {
    return new Contract(address, _abi, signerOrProvider) as SanityChecks;
  }
}
